import { render } from "./paid_installments.vue?vue&type=template&id=aaf9f4e4"
import script from "./paid_installments.vue?vue&type=script&lang=js"
export * from "./paid_installments.vue?vue&type=script&lang=js"

import "./paid_installments.vue?vue&type=style&index=0&id=aaf9f4e4&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__